<template>
    <section id="registry-view">
        <h2>Our Registry</h2>
        <ul class="stores">
            <li>
                <a
                    href="http://tgt.gifts/maggiandjordan"
                    target="_blank"
                >
                    <img src="images/target-logo.jpg" alt="Target" />
                </a>
            </li>
            <li>
                <a
                    href="https://www.westelm.com/registry/vxdg2sclq6/registry-list.html"
                    target="_blank"
                >
                    <img src="images/west-elm.png" alt="West Elm" />
                </a>
            </li>
        </ul>
    </section>
</template>

<script>
export default {
    name: 'registries-view',
    data: () => ({})
};
</script>



// WEBPACK FOOTER //
// src/views/registries.vue?65e39291